export default __webpack_public_path__ + "static/media/fallback.f4985035.svg";